import { useState, useContext } from "react";
import { AuthContext } from "../context/context";
import Headline from "../Components/Elements/Headline";
import StartMessage from "../Components/Elements/StartMessage";
import GoalMetricsCards from "../Components/Cards/GoalMetricsCards";
import GoalCategoriesColumns from "../Components/Cards/GoalCategoriesColumns";
import { deleteGoal } from "../api";  
import PageContentContainer from "../Components/ContentContainers/PageContentContainer";
import { useLanguage } from "../context/LanguageContext";
import Toast from "../Components/Elements/Toast";
import React from "react";

export default function Goals() {
    const { userData, setUserData } = useContext(AuthContext);
    const { copy } = useLanguage();

    // Toast state
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState(""); // 'success' or 'error'

    const goals = Array.isArray(userData?.goals) ? userData.goals : [];

    const handleDeleteClick = async (goalId) => {
        try {
            console.log("Deleting goal with ID:", goalId);
            const result = await deleteGoal(goalId);

            if (!result) {
                console.error("Failed to delete goal");
                setToastMessage("Failed to delete goal.");
                setToastType("error");
                return;
            }

            console.log("Goal deleted successfully");

            const newUserData = { ...userData };
            newUserData.goals = newUserData.goals.filter(g => g.id !== goalId);
            setUserData(newUserData);
            setToastMessage("Goal deleted successfully.");
            setToastType("success");
        } catch (err) {
            console.error("Error deleting goal:", err.message);
            setToastMessage("Error deleting goal: " + err.message);
            setToastType("error");
        }
    };

    // Auto-dismiss toast after 3 seconds
    React.useEffect(() => {
        if (toastMessage) {
            const timer = setTimeout(() => {
                setToastMessage("");
                setToastType("");
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [toastMessage]);

    const handleCloseToast = () => {
        setToastMessage("");
        setToastType("");
    };

    return (
        <>
            {toastMessage && (
                <Toast message={toastMessage} type={toastType} onClose={handleCloseToast} />
            )}
            <PageContentContainer>
                {goals.length > 0 ? (
                    <>
                        <div className="hidden md:block">
                            <Headline 
                                headline={copy.goals.headline}
                                description={copy.goals.description}
                            />
                        </div>
                        <div className="flex flex-col gap-10 pb-16">
                            <GoalMetricsCards />
                            <GoalCategoriesColumns handleDeleteClick={handleDeleteClick} />
                        </div>
                    </>
                ) : (
                    <StartMessage 
                        title={copy.start_message.headline}
                        message={copy.start_message.description}
                    />
                )}
            </PageContentContainer>
        </>
    );
}
